import { useTenant } from '../context/TenantContext'

interface LogoProps {
  className?: string
  size?: number
}

export function Logo({ className, size = 120 }: LogoProps) {
  const { tenant, loading } = useTenant()

  // While the org is still being resolved, keep the space but show nothing:
  // otherwise the German default logo flashes before the org's own appears.
  if (loading && !tenant) {
    return <span aria-hidden className={className} style={{ display: 'inline-block', width: size, height: size }} />
  }

  const logoSrc = tenant?.logoUrl || '/logo.svg'
  const altText = tenant?.companyName || 'GAM Medical'

  return (
    <img
      src={logoSrc}
      alt={altText}
      width={size}
      height={size}
      className={className}
    />
  )
}
